import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import Highcharts, { Options, Chart, LangOptions } from 'highcharts';

const GraphContainer = styled.div`
  position: relative;
`;

Highcharts.dateFormats = {
  W(timestamp) {
    return moment(timestamp).format('WW');
  },
};

interface Props {
  t: i18next.TFunction;
  options: Options;
  redrawOptions?: {
    redraw?: boolean;
    oneToOne?: boolean;
  };
}

class HighchartsReact extends React.Component<Props> {
  containerRef: React.RefObject<HTMLDivElement>;
  chart: Chart | undefined = undefined;

  constructor(props: Props) {
    super(props);

    this.containerRef = React.createRef();
  }

  componentDidMount() {
    const { options } = this.props;
    this.setTranslations();
    this.chart = Highcharts.chart(this.containerRef.current as HTMLDivElement, options);
  }

  componentDidUpdate() {
    const redrawOptions = this.props.redrawOptions || {};
    const redraw = typeof redrawOptions.redraw === 'boolean' ? redrawOptions.redraw : true;
    const oneToOne = typeof redrawOptions.oneToOne === 'boolean' ? redrawOptions.oneToOne : false;
    this.chart!.update(this.props.options, redraw, oneToOne);
  }

  componentWillUnmount() {
    this.chart!.destroy();
  }

  setTranslations() {
    const { t } = this.props;
    const lang: LangOptions = {};
    const shortMonths = t('x.short_months').split(', ');
    const months = t('x.months').split(', ');
    const weekdays = t('x.weekdays').split(', ');
    if (typeof shortMonths === 'object' && shortMonths.length > 1) {
      lang.shortMonths = shortMonths;
    }
    if (typeof months === 'object' && months.length > 1) {
      lang.months = months;
    }
    if (typeof weekdays === 'object' && weekdays.length > 1) {
      lang.weekdays = weekdays;
    }

    Highcharts.setOptions({ lang });
  }

  render() {
    return (
      <GraphContainer data-transition="x.short_months,x.months,x.weekdays">
        <div ref={this.containerRef} />
      </GraphContainer>
    );
  }
}

export default HighchartsReact;
